module.exports = __webpack_public_path__ + "static/gattaca-background-d89f4eeb846ce6917f4fa3451aaa53d6.mp4";